import { LANGUAGES } from 'containers/constants'

import {revertCartPaymentProcessing, clearErroronSuccess} from "../Cart/actions";
import {mediatorService} from "../../services/apiService";
import {
    WS_CONNECT,
    SHOW_BACK_BUTTON,
    GET_WEBSTOCKET_ID,
    FETCH_WEB_SOCKET_SESSION_ID,
    TOGGLE_APP_VISIBILITY,
    INITIALISE_APP,
    CLOSE_APP,
    SET_APP_LOCALE,
    CYBERSOURCE_ERROR,
    WEB_SOCKET_CONNECTION_ERROR,
    TAX_SERVICE_UNAVAILABLE_ERROR,
    TAX_COMPUTATION_ERROR,
    CREATE_SIGNATURE_ERROR,
    APP_CLEAR_ERROR,
    PAYMENT_ERROR,
    CLOSE_MODAL_WARNING,
    URLS,
    UPDATE_ROUTE,
    SET_IS_MOBILE,
} from "../constants";

import {getUserSelectedLanguage} from "../../components/LanguageSwitcher/locale";

export const showBackButton = (value) => ({
    type: SHOW_BACK_BUTTON,
    value,
});

export const toggleAppVisibility = (value) => ({
    type: TOGGLE_APP_VISIBILITY,
    value,
});

export const setIsMobile = (value) => ({
    type: SET_IS_MOBILE,
    value,
});

export const warnCloseAppWindow = () => async (dispatch, getState) => {
  dispatch(closeApp());
};

export const initialiseApp = () => (dispatch) => {
    dispatch(setAppLocale(getUserSelectedLanguage(LANGUAGES)));
    dispatch(toggleAppVisibility(true));
    dispatch(getAndInitiateScreenSize());
    dispatch({
        type: INITIALISE_APP,
        value: true,
    });
};

export const getAndInitiateScreenSize = () => (dispatch) => {
    const queryParams = new URLSearchParams(window.location.search);
    const screen = queryParams.get("screen");
    if (screen === "mobile") {
        dispatch(setIsMobile(true));
    } else if (screen === "desktop") {
        dispatch(setIsMobile(false));
    }
};


export const closeInitialisedApp = () => (dispatch, getState) => {
  dispatch(cancelWarning())
  dispatch(closeApp())
}

export const closeApp = () => dispatch => {
  window.parent.postMessage({ type: 'isChatInitialised', value: false }, '*')
  dispatch({
    type: INITIALISE_APP,
    value: false,
  })
}

export const clearAppState = () => ({
  type: CLOSE_APP,
})

export const cancelWarning = () => ({
  type: APP_CLEAR_ERROR,
})

export const getWebSocketId = () => ({
  type: GET_WEBSTOCKET_ID,
})

export const setAppLocale = locale => ({
  type: SET_APP_LOCALE,
  locale,
})

export const updateRoute = (main, sub) => ({
  type: UPDATE_ROUTE,
  value: { main, sub },
})

export const fetchWebSocketId = () => async dispatch => {
  try {
    const payload = await mediatorService.getSessionId()
    dispatch({
      type: FETCH_WEB_SOCKET_SESSION_ID,
      payload,
    })
    dispatch(subscribeToMediator())
  } catch (payload) {
    console.log('FETCH_WEB_SOCKET_SESSION_ID_ERROR', payload)
    dispatch(updateRoute(URLS.CHAT_ERROR, ''))
  }
}

export const subscribeToMediator = () => async (dispatch, getState) => {
  try {
    const { webSocketId } = getState().app
    dispatch({
      type: WS_CONNECT,
      payload: webSocketId,
    })
  } catch (payload) {
    console.log('FETCH_WEB_SOCKET_SESSION_ID_ERROR', payload)
    dispatch(updateRoute(URLS.CHAT_ERROR, ''))
  }
}

export const handleServerError = () => dispatch => {
  dispatch(updateRoute(URLS.CHAT_ERROR, ''))
}

const retryActionHolder = {
  [WEB_SOCKET_CONNECTION_ERROR]: handleServerError,
  [TAX_SERVICE_UNAVAILABLE_ERROR]: clearErroronSuccess,
  [CYBERSOURCE_ERROR]: clearErroronSuccess,
  [TAX_COMPUTATION_ERROR]: clearErroronSuccess,
  [CREATE_SIGNATURE_ERROR]: revertCartPaymentProcessing,
  [CLOSE_MODAL_WARNING]: closeInitialisedApp,
  [PAYMENT_ERROR]: revertCartPaymentProcessing,
}
export const retryActionDispatcher = () => (dispatch, getState) => {
  const errorCode = getState().app.modal.code
  dispatch(retryActionHolder[errorCode]())
}



// WEBPACK FOOTER //
// ./src/containers/App/actions.js